import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableContainer, Table, TableBody, TableRow, TableCell, IconButton } from "@material-ui/core";
import TableHeader from './../../Common/TableHeader';
import ListIcon from '@material-ui/icons/List';
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from './../../../utils/guid';
import NoData from './../../Common/NoDataRow';

const useStyles = theme => ({
    table: {
        marginTop: theme.spacing(1)
    },
    cell: {
        textAlign: "center",
        padding: 0
    }
});

const header = [t.username, t.emailAddressLabel, t.firstAndLastName, t.phone, t.manage];

const OperatorsTable = props => {
    const { classes, operators, onOperatorDetailsShow } = props;

    const printTable = data => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={5} />;
        return data.map(row => (
            <TableRow key={guid()}>
                <TableCell className={classes.cell}>
                    {row.operator_login}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.operator_email}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.operator_nazwa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.operator_telefon}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton onClick={() => onOperatorDetailsShow(row.operator_id)}>
                        <ListIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <TableContainer className={classes.table}>
            <Table stickyHeader>
                <TableHeader data={header} />
                <TableBody>
                    {printTable(operators)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

OperatorsTable.propTypes = {
    classes: PropTypes.object,
    operators: PropTypes.array,
    onOperatorDetailsShow: PropTypes.func
};

export default withStyles(useStyles)(OperatorsTable);
